import { WorkflowsRoutingModule } from './workflows-routing.module';
import { EditWorkflowStatesComponent } from './edit-workflows/edit-workflow-states/edit-workflow-states.component';
import { EditWorkflowInformationComponent } from './edit-workflows/edit-workflow-information/edit-workflow-information.component';
import { EditWorkflowsComponent } from './edit-workflows/edit-workflows.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexWorkflowsComponent } from './index-workflows/index-workflows.component';
import { EditWorkflowTransitionsComponent } from './edit-workflows/edit-workflow-transitions/edit-workflow-transitions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CommonComponentsModule } from '../../common-components/common-components.module';
import { EditWorkflowTransitionPropertiesComponent } from './edit-workflows/edit-workflow-transitions/edit-workflow-transition-properties/edit-workflow-transition-properties.component';

@NgModule({
    declarations: [
        IndexWorkflowsComponent,
        EditWorkflowsComponent,
        EditWorkflowInformationComponent,
        EditWorkflowStatesComponent,
        EditWorkflowTransitionsComponent,
        EditWorkflowTransitionPropertiesComponent
    ],
    imports: [CommonModule, CommonComponentsModule, FormsModule, ReactiveFormsModule, MaterialModule, PipesModule, WorkflowsRoutingModule]
})
export class WorkflowsModule {}
